import axios from 'axios';
import { IEnderecoApiCEP } from '../models/IEnderecoApiCEP';
import { unMasked } from './cpf';

export interface IResponseErrorEnderecoAPI {
    mensagem:string

}

export const buscarEnderecoApi = async (cep: string) => {
    try {
        cep = cep.replace(/\D/g, '');                
        if (cep !== "") {
            //Expressão regular para validar o CEP.
            if (cep.length === 8) {
                var validacep = /^[0-9]{8}$/;
                if (validacep.test(cep)) {
                    return await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
                        .then((response) => {
                            if (response.data.erro) {
                                return Promise.reject({mensagem:'CEP inválido'} as IResponseErrorEnderecoAPI)
                            }
                            else {
                                return response.data as IEnderecoApiCEP;
                            }
                        })
                        .catch(() => {
                           return Promise.reject({mensagem:'Falha na requisição do CEP'} as IResponseErrorEnderecoAPI)
                        })
                        .finally(() => { })
                }
                else {
                    return Promise.reject({mensagem:'CEP inválido'} as IResponseErrorEnderecoAPI)
                }
            }
            return Promise.reject({mensagem:"O CEP necessita de 8 caracteres"} as IResponseErrorEnderecoAPI)          
        }
    }
    catch {
        return Promise.reject({mensagem:'CEP inválido'} as IResponseErrorEnderecoAPI)
    }
}



export const validarCEP = (value: string) => {
    if (!value) return Promise.resolve('')
    value = unMasked(value)
    if (value.length < 8) {
        return Promise.reject('Campo deve conter 8 dígitos');
    }
    return Promise.resolve();

}
